import React, { useState, useEffect, useCallback } from "react";
import { FormControl, InputLabel, OutlinedInput } from "@mui/material";
import AddIcon from "@mui/icons-material/AddBoxOutlined";
import AddMore from "./../../../assets/add-more.svg";
import Delete from "./../../../assets/delete.svg";
import SwitchButton from "../../../components/SwitchButton/SwitchButton";

const Ranges = ({
  isMobile,
  isPadding,
  onRangesChange,
  onRangesOnlyChange,
  disabled,
}) => {
  const [rangesOnly, setRangesOnly] = useState(false);
  // Initialize state with a default group
  const [inputGroups, setInputGroups] = useState([
    { id: 1, min_qty: "", max_qty: "", price_range: "" },
  ]);

  const handleRangeChange = (groupId, inputName, value) => {
    setInputGroups((prevGroups) =>
      prevGroups.map((group) =>
        group.id === groupId ? { ...group, [inputName]: value } : group,
      ),
    );
  };

  const addGroup = () => {
    const newId =
      inputGroups.length > 0 ? inputGroups[inputGroups.length - 1].id + 1 : 1;
    setInputGroups([
      ...inputGroups,
      { id: newId, min_qty: "", max_qty: "", price_range: "" },
    ]);
  };

  const deleteGroup = (groupId) => {
    if (inputGroups.length > 1) {
      setInputGroups((prevGroups) =>
        prevGroups.filter((group) => group.id !== groupId),
      );
    }
  };

  // Prepare and send ranges data to parent
  const prepareRangesData = useCallback(() => {
    const formData = new FormData();

    // Collect non-empty groups
    const filteredGroups = inputGroups.filter(
      (group) => group.min_qty && group.max_qty && group.price_range,
    );

    // Append each range as separate entries
    filteredGroups.forEach((group) => {
      formData.append("min_qty[]", group.min_qty);
      formData.append("max_qty[]", group.max_qty);
      formData.append("price_range[]", group.price_range);
    });

    return formData;
  }, [inputGroups]);

  // Send data to parent whenever input groups change
  useEffect(() => {
    if (onRangesChange) {
      const timeoutId = setTimeout(() => {
        const formData = prepareRangesData();
        onRangesChange(formData);
      }, 300); // Debounce for 300ms

      return () => clearTimeout(timeoutId);
    }
  }, [inputGroups, onRangesChange, prepareRangesData]);

  const handleToggle = () => {
    if (disabled) return;
    const next = !rangesOnly;
    setRangesOnly(next);
    if (onRangesOnlyChange) onRangesOnlyChange(next);
  };

  return (
    <div
      className="ranges-container"
      style={{ padding: isPadding ? "30px" : "0px" }}
    >
      <div
        className="variations-header"
        style={{
          marginBottom: "16px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <h4>نطاقات الاسعار</h4>

        <div className="" style={{ display: "flex", alignItems: "center" }}>
          {disabled && (
            <span
              style={{ fontSize: "12px", color: "#888", marginLeft: "8px" }}
            >
              (معطل - تم تفعيل السمات)
            </span>
          )}
          <SwitchButton
            checked={rangesOnly}
            onChange={handleToggle}
            disabled={disabled}
          />
        </div>
      </div>

      {rangesOnly && (
        <>
          {inputGroups.map((group) => (
            <div key={group.id} className="range-item">
              <FormControl sx={{ flex: "1" }} variant="outlined">
                <InputLabel
                  htmlFor={`range-from-${group.id}`}
                  shrink
                  sx={{
                    background: "white",
                    transformOrigin: "right top",
                    transform: "translate(14px, -9px) scale(0.8)",
                    right: 24,
                    left: "auto",
                    paddingLeft: "4px",
                    paddingRight: "4px",
                  }}
                >
                  من
                </InputLabel>
                <OutlinedInput
                  sx={{ borderRadius: "8px" }}
                  id={`range-from-${group.id}`}
                  type="text"
                  notched
                  value={group.min_qty}
                  onChange={(e) =>
                    handleRangeChange(group.id, "min_qty", e.target.value)
                  }
                />
              </FormControl>

              <FormControl sx={{ flex: "1" }} variant="outlined">
                <InputLabel
                  htmlFor={`range-to-${group.id}`}
                  shrink
                  sx={{
                    background: "white",
                    transformOrigin: "right top",
                    transform: "translate(14px, -9px) scale(0.8)",
                    right: 24,
                    left: "auto",
                    paddingLeft: "4px",
                    paddingRight: "4px",
                  }}
                >
                  الي
                </InputLabel>
                <OutlinedInput
                  sx={{ borderRadius: "8px" }}
                  id={`range-to-${group.id}`}
                  type="text"
                  notched
                  value={group.max_qty}
                  onChange={(e) =>
                    handleRangeChange(group.id, "max_qty", e.target.value)
                  }
                />
              </FormControl>

              <FormControl sx={{ flex: "1" }} variant="outlined">
                <InputLabel
                  htmlFor={`range-price-${group.id}`}
                  shrink
                  sx={{
                    background: "white",
                    transformOrigin: "right top",
                    transform: "translate(14px, -9px) scale(0.8)",
                    right: 24,
                    left: "auto",
                    paddingLeft: "4px",
                    paddingRight: "4px",
                  }}
                >
                  السعر
                </InputLabel>
                <OutlinedInput
                  sx={{ borderRadius: "8px" }}
                  id={`range-price-${group.id}`}
                  type="text"
                  notched
                  value={group.price_range}
                  onChange={(e) =>
                    handleRangeChange(group.id, "price_range", e.target.value)
                  }
                />
              </FormControl>

              {isMobile ? (
                <AddIcon className="icon" onClick={addGroup} />
              ) : (
                <img src={AddMore} alt="" onClick={addGroup} />
              )}
              {inputGroups.length > 1 && (
                <img
                  src={Delete}
                  alt=""
                  onClick={() => deleteGroup(group.id)}
                />
              )}
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default Ranges;
